import { useQuery } from '@tanstack/react-query'
import { PURSE_KEYS } from '@/queries/program_purses/keys.ts'
import {
  getProgramPurses,
  GetProgramPursesParams,
} from '@/queries/program_purses/requests.ts'

export const useProgramPursesQuery = (
  request: GetProgramPursesParams,
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: PURSE_KEYS.PURSES(request.programId),
    queryFn: () => getProgramPurses(request),
    enabled,
  })
}
